import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-gray-800 text-white py-8">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <h3 className="text-xl font-bold mb-4">公司名称</h3>
            <p className="text-gray-400">为您提供最优质的服务</p>
          </div>
          <div>
            <h3 className="text-xl font-bold mb-4">联系方式</h3>
            <p className="text-gray-400">邮箱：contact@Toop.vip</p>
            <p className="text-gray-400">电话：7788-171-678</p>
          </div>
          <div>
            <h3 className="text-xl font-bold mb-4">关注我们</h3>
            <div className="flex space-x-4">
              <a href="#" className="text-gray-400 hover:text-white">微信</a>
              <a href="#" className="text-gray-400 hover:text-white">微博</a>
            </div>
          </div>
        </div>
        <div className="mt-8 text-center text-gray-400">
          <p>&copy; 2025 ToopVIP. 版权所有.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 